module.exports = __webpack_public_path__ + "static/media/bkst_site_home.60770568.jpg";